// Adapted from https://github.com/dandean/guid
// Original Source MIT License
// Copyright 2009, 2010 Dan Dean. All rights reserved.
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/* tslint:disable */

const validator = new RegExp(
    '^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$',
    'i'
);

function gen(count: number): string {
    let out = '';
    for (let i = 0; i < count; i++) {
        out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return out;
}

export class GuidGenerator {
    public generateGuid(): Guid {
        return new Guid([gen(2), gen(1), gen(1), gen(1), gen(3)].join('-'));
    }

    public generateGuidString(): string {
        return [gen(2), gen(1), gen(1), gen(1), gen(3)].join('-');
    }
}

export class Guid {
    public static EMPTY = '00000000-0000-0000-0000-000000000000';
    public value: string = Guid.EMPTY;

    constructor(guid: string | Guid) {
        if (!guid) {
            throw new TypeError('Invalid argument; `value` has no value.');
        }

        this.value = Guid.EMPTY;

        if (guid && guid instanceof Guid) {
            this.value = guid.toString();
        } else if (
            guid &&
            Object.prototype.toString.call(guid) === '[object String]' &&
            Guid.isGuid(guid)
        ) {
            this.value = guid as string;
        }
    }

    public equals(other: any) {
        // Comparing string `value` against provided `guid` will auto-call
        // toString on `guid` for comparison
        return Guid.isGuid(other) && this.value == other;
    }

    public isEmpty() {
        return this.value === Guid.EMPTY;
    }

    public toString() {
        return this.value;
    }

    public toJSON() {
        return this.value;
    }

    public static isGuid(value: any) {
        return (
            value && (value instanceof Guid || validator.test(value.toString()))
        );
    }
}
